import { ɵɵdefineDirective, ɵsetClassMetadata, Directive, Input, ɵɵdefineInjectable, Injectable, ɵɵelementStart, ɵɵtext, ɵɵpipe, ɵɵelementEnd, ɵɵelement, ɵɵnextContext, ɵɵadvance, ɵɵtextInterpolate1, ɵɵpipeBind1, ɵɵproperty, ɵɵpureFunction1, ɵɵtemplate, ɵɵgetCurrentView, ɵɵlistener, ɵɵrestoreView, ɵɵsanitizeHtml, ɵɵdirectiveInject, ɵɵdefineComponent, Component, ɵɵattribute, ɵɵclassProp, ɵɵelementContainerStart, ɵɵelementContainerEnd, ɵɵelementContainer, ɵɵviewQuery, ɵɵqueryRefresh, ɵɵloadQuery, ViewChild, EventEmitter, Output, ɵɵinject, ɵɵcontentQuery, TemplateRef, ContentChildren, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule, ɵɵsetComponentScope } from '@angular/core';
import { HttpService } from '@akeela/properties';
import { NgIf, NgForOf, NgStyle, NgClass, NgTemplateOutlet, CommonModule, NgComponentOutlet, NgSwitch, NgSwitchCase, NgSwitchDefault, NgPlural, NgPluralCase, AsyncPipe, UpperCasePipe, LowerCasePipe, JsonPipe, SlicePipe, DecimalPipe, PercentPipe, TitleCasePipe, CurrencyPipe, DatePipe, I18nPluralPipe, I18nSelectPipe, KeyValuePipe } from '@angular/common';
import { BehaviorSubject, Observable } from 'rxjs';
import { I18nPipe, I18nModule, FormatPipe, NumberI18nPipe, NumberTransformPipe } from '@akeela/i18n';
import { NgbDropdownConfig, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbModule, NgbAccordion, NgbPanel, NgbPanelTitle, NgbPanelContent, NgbPanelHeader, NgbPanelToggle, NgbAlert, NgbButtonLabel, NgbCheckBox, NgbRadioGroup, NgbRadio, NgbCarousel, NgbSlide, NgbCollapse, NgbDatepicker, NgbInputDatepicker, NgbDropdownAnchor, NgbDropdownItem, ɵm, NgbPagination, NgbPaginationEllipsis, NgbPaginationFirst, NgbPaginationLast, NgbPaginationNext, NgbPaginationNumber, NgbPaginationPrevious, NgbPopover, NgbProgressbar, NgbRating, NgbTabset, NgbTab, NgbTabContent, NgbTabTitle, NgbTimepicker, NgbTooltip, NgbTypeahead, NgbHighlight } from '@ng-bootstrap/ng-bootstrap';
import { isNullOrUndefined } from 'util';
import html2pdf from 'html2pdf.js';
import { Validators, FormBuilder, FormsModule, ReactiveFormsModule, ɵangular_packages_forms_forms_y, NgSelectOption, ɵangular_packages_forms_forms_x, DefaultValueAccessor, NumberValueAccessor, RangeValueAccessor, CheckboxControlValueAccessor, SelectControlValueAccessor, SelectMultipleControlValueAccessor, RadioControlValueAccessor, NgControlStatus, NgControlStatusGroup, RequiredValidator, MinLengthValidator, MaxLengthValidator, PatternValidator, CheckboxRequiredValidator, EmailValidator, NgModel, NgModelGroup, NgForm, FormControlDirective, FormGroupDirective, FormControlName, FormGroupName, FormArrayName } from '@angular/forms';
import { RouterModule, RouterOutlet, RouterLink, RouterLinkWithHref, RouterLinkActive, ɵangular_packages_router_router_l } from '@angular/router';

class ContentDirective {
    constructor() {
    }
}
/** @nocollapse */ ContentDirective.ɵfac = function ContentDirective_Factory(t) { return new (t || ContentDirective)(); };
/** @nocollapse */ ContentDirective.ɵdir = ɵɵdefineDirective({ type: ContentDirective, selectors: [["", "products-akeela-content", ""]], inputs: { componentName: "componentName" } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ContentDirective, [{
        type: Directive,
        args: [{
                selector: '[products-akeela-content]'
            }]
    }], function () { return []; }, { componentName: [{
            type: Input
        }] }); })();

class ProductsService {
    constructor() {
        this.currentProduct$ = new BehaviorSubject(null);
    }
}
/** @nocollapse */ ProductsService.ɵfac = function ProductsService_Factory(t) { return new (t || ProductsService)(); };
/** @nocollapse */ ProductsService.ɵprov = ɵɵdefineInjectable({ token: ProductsService, factory: ProductsService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ProductsService, [{
        type: Injectable
    }], function () { return []; }, null); })();

function RecursiveComponent_div_0_div_1_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 7);
    ɵɵelementStart(1, "h4", 8);
    ɵɵtext(2);
    ɵɵpipe(3, "i18n");
    ɵɵelementEnd();
    ɵɵelement(4, "br");
    ɵɵelementEnd();
} if (rf & 2) {
    const product_r3 = ɵɵnextContext(2).$implicit;
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(3, 1, product_r3.name), "");
} }
const _c0 = function (a0) { return { "margin-left.rem": a0 }; };
function RecursiveComponent_div_0_div_1_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 7);
    ɵɵelementStart(1, "h5", 9);
    ɵɵtext(2);
    ɵɵpipe(3, "i18n");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const product_r3 = ɵɵnextContext(2).$implicit;
    const ctx_r6 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngStyle", ɵɵpureFunction1(4, _c0, ctx_r6.paddingLeft));
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(3, 2, product_r3.name), "");
} }
function RecursiveComponent_div_0_div_1_div_1_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵelement(1, "products-recursive", 10);
    ɵɵelementEnd();
} if (rf & 2) {
    const product_r3 = ɵɵnextContext(2).$implicit;
    const ctx_r7 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("products", product_r3.isSimilarTo)("principal", false)("paddingLeft", ctx_r7.paddingLeft + 2)("paddingLeft", 0)("iconProduct", ctx_r7.iconProduct)("styleBox", ctx_r7.styleBox);
} }
function RecursiveComponent_div_0_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div", 4);
    ɵɵtemplate(2, RecursiveComponent_div_0_div_1_div_1_div_2_Template, 5, 3, "div", 5);
    ɵɵtemplate(3, RecursiveComponent_div_0_div_1_div_1_div_3_Template, 4, 6, "div", 6);
    ɵɵelementEnd();
    ɵɵtemplate(4, RecursiveComponent_div_0_div_1_div_1_span_4_Template, 2, 6, "span", 0);
    ɵɵelementEnd();
} if (rf & 2) {
    const product_r3 = ɵɵnextContext().$implicit;
    const ctx_r4 = ɵɵnextContext(2);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r4.principal);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r4.principal);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (product_r3.isSimilarTo == null ? null : product_r3.isSimilarTo.length) > 0);
} }
function RecursiveComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtemplate(1, RecursiveComponent_div_0_div_1_div_1_Template, 5, 3, "div", 0);
    ɵɵelementEnd();
} if (rf & 2) {
    const product_r3 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (product_r3.isSimilarTo == null ? null : product_r3.isSimilarTo.length) > 0);
} }
function RecursiveComponent_div_0_div_3_div_1_div_2_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 20);
} if (rf & 2) {
    const product_r12 = ɵɵnextContext(3).$implicit;
    ɵɵproperty("ngClass", (product_r12.image == null ? null : product_r12.image.thumbnail) ? product_r12.image == null ? null : product_r12.image.thumbnail : "fab fa-product-hunt");
} }
function RecursiveComponent_div_0_div_3_div_1_div_2_img_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 21);
} }
function RecursiveComponent_div_0_div_3_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtemplate(1, RecursiveComponent_div_0_div_3_div_1_div_2_i_1_Template, 1, 1, "i", 18);
    ɵɵtemplate(2, RecursiveComponent_div_0_div_3_div_1_div_2_img_2_Template, 1, 0, "img", 19);
    ɵɵelementEnd();
} if (rf & 2) {
    const product_r12 = ɵɵnextContext(2).$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", product_r12.image == null ? null : product_r12.image.thumbnail);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !(product_r12.image == null ? null : product_r12.image.thumbnail));
} }
function RecursiveComponent_div_0_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 13);
    ɵɵlistener("click", function RecursiveComponent_div_0_div_3_div_1_Template_div_click_0_listener() { ɵɵrestoreView(_r21); const product_r12 = ɵɵnextContext().$implicit; const ctx_r19 = ɵɵnextContext(2); return ctx_r19.select_product(product_r12.identifier); });
    ɵɵelementStart(1, "div", 14);
    ɵɵtemplate(2, RecursiveComponent_div_0_div_3_div_1_div_2_Template, 3, 2, "div", 0);
    ɵɵelementStart(3, "div", 15);
    ɵɵtext(4);
    ɵɵpipe(5, "i18n");
    ɵɵelementEnd();
    ɵɵelement(6, "div", 16);
    ɵɵpipe(7, "i18n");
    ɵɵelement(8, "a", 17);
    ɵɵpipe(9, "i18n");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const product_r12 = ɵɵnextContext().$implicit;
    const ctx_r13 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngStyle", ctx_r13.styleBox);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r13.iconProduct);
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(5, 5, product_r12.name), " ");
    ɵɵadvance(2);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(7, 7, product_r12 == null ? null : product_r12.description), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(9, 9, "@i18n-product-link-plan"), ɵɵsanitizeHtml);
} }
function RecursiveComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 11);
    ɵɵtemplate(1, RecursiveComponent_div_0_div_3_div_1_Template, 10, 11, "div", 12);
    ɵɵelementEnd();
} if (rf & 2) {
    const product_r12 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !product_r12.isSimilarTo || !((product_r12.isSimilarTo == null ? null : product_r12.isSimilarTo.length) > 0));
} }
function RecursiveComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtemplate(1, RecursiveComponent_div_0_div_1_Template, 2, 1, "div", 1);
    ɵɵelementStart(2, "div", 2);
    ɵɵtemplate(3, RecursiveComponent_div_0_div_3_Template, 2, 1, "div", 3);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r0.products);
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", ctx_r0.products);
} }
class RecursiveComponent {
    constructor(_product) {
        this._product = _product;
    }
    ngOnInit() {
    }
    select_product(evnt) {
        this._product.currentProduct$.next(evnt);
    }
}
/** @nocollapse */ RecursiveComponent.ɵfac = function RecursiveComponent_Factory(t) { return new (t || RecursiveComponent)(ɵɵdirectiveInject(ProductsService)); };
/** @nocollapse */ RecursiveComponent.ɵcmp = ɵɵdefineComponent({ type: RecursiveComponent, selectors: [["products-recursive"]], inputs: { products: "products", iconProduct: "iconProduct", styleBox: "styleBox", principal: "principal", paddingLeft: "paddingLeft" }, decls: 1, vars: 1, consts: [[4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "list", "d-flex", "bd-highlight", "justify-content-center", "text-center", "list-flex", "flex-wrap", "pb-3", "pt-2"], ["class", "bd-highlight pr-0 pr-md-1 pl-0 pl-md-1   w-33 w-sm-100 order-3", 4, "ngFor", "ngForOf"], [1, "list", "d-flex", "bd-highlight", "justify-content-center", "text-center", "list-flex", "flex-wrap", "pt-2"], ["class", "bd-highlight  w-100 order-1 ", 4, "ngIf"], ["class", "bd-highlight  w-100 order-1  ", 4, "ngIf"], [1, "bd-highlight", "w-100", "order-1"], [1, "font-weight-normal", "text-dark"], [1, "font-weight-normal", "text-secondary", 3, "ngStyle"], [1, "w-100", 3, "products", "principal", "paddingLeft", "iconProduct", "styleBox"], [1, "bd-highlight", "pr-0", "pr-md-1", "pl-0", "pl-md-1", "w-33", "w-sm-100", "order-3"], ["class", "shadow  mt-3 mb-3 active-cursor card w-100 border  animated fadeIn", 3, "click", 4, "ngIf"], [1, "shadow", "mt-3", "mb-3", "active-cursor", "card", "w-100", "border", "animated", "fadeIn", 3, "click"], [1, "card-body", 3, "ngStyle"], [1, "font-weight-bold", "mt-3"], [3, "innerHTML"], ["href", "javascript:void()", 3, "innerHTML"], ["class", "size-class  icon-class", "aria-hidden", "true", 3, "ngClass", 4, "ngIf"], ["class", "size-img", "src", "assets/public/images/completa.svg", 4, "ngIf"], ["aria-hidden", "true", 1, "size-class", "icon-class", 3, "ngClass"], ["src", "assets/public/images/completa.svg", 1, "size-img"]], template: function RecursiveComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, RecursiveComponent_div_0_Template, 4, 2, "div", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", (ctx.products == null ? null : ctx.products.length) > 0);
    } }, directives: [NgIf, NgForOf, NgStyle, RecursiveComponent, NgClass], pipes: [I18nPipe], styles: ["*[_ngcontent-%COMP%]{--border-card-product:var(--ak-color-1);--border-card-product-hover:var(--ak-color-2);--icon-card-product:var(--ak-color-1)}.icon-class[_ngcontent-%COMP%]{color:var(--icon-card-product)}.box-white-rgba[_ngcontent-%COMP%]{background-color:transparent;border:1.2px solid #fff;color:#444;margin:2px;padding:16px 15px;text-align:center}.box-white-rgba.product[_ngcontent-%COMP%]{cursor:pointer;min-height:8rem}.box-white-rgba.product[_ngcontent-%COMP%]:hover{border:1.2px solid #ccc;color:#000}.box-white-rgba[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-size:3em}.row.no-gutters[_ngcontent-%COMP%]{margin-left:0;margin-right:0}.p-l-2[_ngcontent-%COMP%]{padding-left:2rem}a[_ngcontent-%COMP%]:hover{text-decoration:inherit}.no-principal[_ngcontent-%COMP%]{padding-left:1rem}.principal[_ngcontent-%COMP%]{font-weight:700;margin-bottom:1rem;margin-left:10px}.m-t-1[_ngcontent-%COMP%]{margin-top:1rem}.m-b-1[_ngcontent-%COMP%]{margin-bottom:1rem}.text-white[_ngcontent-%COMP%]{color:#fff}.card-body[_ngcontent-%COMP%]{border:1px solid var(--border-card-product);border-radius:8px;min-height:280px}.card[_ngcontent-%COMP%]:hover.border{border:1px solid var(--border-card-product-hover);border-color:#aaa!important;border-radius:7px}.size-img[_ngcontent-%COMP%]{height:50px}.size-class[_ngcontent-%COMP%]{font-size:3rem}@media (max-width:768px){.card-body[_ngcontent-%COMP%]{min-height:120px}.w-33[_ngcontent-%COMP%]{width:100%!important}}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(RecursiveComponent, [{
        type: Component,
        args: [{
                selector: 'products-recursive',
                templateUrl: './recursive.component.html',
                styleUrls: ['./recursive.component.css']
            }]
    }], function () { return [{ type: ProductsService }]; }, { products: [{
            type: Input
        }], iconProduct: [{
            type: Input
        }], styleBox: [{
            type: Input
        }], principal: [{
            type: Input
        }], paddingLeft: [{
            type: Input
        }] }); })();

function ProductsComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div", 5);
    ɵɵelement(2, "img", 6);
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
class ProductsComponent {
    constructor(_httpService) {
        this._httpService = _httpService;
    }
    ngOnInit() {
        this._httpService.executeRequest(this.params.endpoint.products.name, this.params.endpoint.products.params).subscribe((response) => {
            this.products = response;
        }, error => {
            this.products = null;
        });
    }
}
/** @nocollapse */ ProductsComponent.ɵfac = function ProductsComponent_Factory(t) { return new (t || ProductsComponent)(ɵɵdirectiveInject(HttpService)); };
/** @nocollapse */ ProductsComponent.ɵcmp = ɵɵdefineComponent({ type: ProductsComponent, selectors: [["products"]], inputs: { params: "params", iconProduct: "iconProduct", styleBox: "styleBox" }, decls: 5, vars: 6, consts: [[1, "animated", "fadeIn", "pl-3", "pr-3", "pr-md-3", "pl-md-4"], [1, "animated", "fadeIn", "mt-3"], [1, "container", "animated", "fadeIn"], [4, "ngIf"], [1, "w-100", 3, "products", "principal", "paddingLeft", "iconProduct", "styleBox"], [1, "text-center", "ml-auto", "mt-3", "mb-3", "pb-3"], ["src", "./assets/public/images/loading.gif", "alt", " "]], template: function ProductsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵtemplate(3, ProductsComponent_div_3_Template, 3, 0, "div", 3);
        ɵɵelementEnd();
        ɵɵelement(4, "products-recursive", 4);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(3);
        ɵɵproperty("ngIf", !ctx.products);
        ɵɵadvance(1);
        ɵɵproperty("products", ctx.products)("principal", true)("paddingLeft", 0)("iconProduct", ctx.iconProduct)("styleBox", ctx.styleBox);
    } }, directives: [NgIf, RecursiveComponent], styles: [".w-box-product[_ngcontent-%COMP%]{margin-left:15px;margin-right:15px}@media (max-width:500px){.w-box-product[_ngcontent-%COMP%]{margin-left:-15px;margin-right:-15px;width:auto!important}}.box-white-rgba[_ngcontent-%COMP%]{border:1px solid transparent;color:#000;margin:2px;padding:16px 15px;text-align:left}.box-white-rgba.header[_ngcontent-%COMP%]{margin-bottom:2rem;padding-bottom:1px;padding-top:1px}.row.no-gutters[_ngcontent-%COMP%]{margin-left:0;margin-right:0}.m-t-3[_ngcontent-%COMP%]{margin-top:3rem}.m-b-3[_ngcontent-%COMP%]{margin-bottom:3rem}.font-color-white[_ngcontent-%COMP%]{color:transparent}.box[_ngcontent-%COMP%]{background-color:transparent;color:#4a4a4a;margin-left:auto;margin-right:auto;width:768px}.box.bg-gray[_ngcontent-%COMP%]{min-height:auto}@media (max-width:768px){.box[_ngcontent-%COMP%]{font-size:1rem!important}.section-title[_ngcontent-%COMP%]{font-size:.875rem!important}}@media (max-width:992px){.box[_ngcontent-%COMP%]{width:auto!important}}.text-white[_ngcontent-%COMP%]{color:#fff}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ProductsComponent, [{
        type: Component,
        args: [{
                selector: 'products',
                templateUrl: './products.component.html',
                styleUrls: ['./products.component.css']
            }]
    }], function () { return [{ type: HttpService }]; }, { params: [{
            type: Input
        }], iconProduct: [{
            type: Input
        }], styleBox: [{
            type: Input
        }] }); })();

function PlanRequirementsComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 4);
    ɵɵelement(1, "br");
    ɵɵelement(2, "br");
    ɵɵelementStart(3, "div", 5);
    ɵɵelement(4, "img", 6);
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function PlanRequirementsComponent_div_3_div_1_i_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 19);
} }
function PlanRequirementsComponent_div_3_div_1_i_11_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 20);
} }
function PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_ng_container_1_div_1_span_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 34);
    ɵɵtext(1, " * ");
    ɵɵelementEnd();
} }
function PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_ng_container_1_div_1_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 35);
    ɵɵelementStart(1, "div", 36);
    ɵɵelement(2, "i", 37);
    ɵɵelementStart(3, "div", 38);
    ɵɵelementStart(4, "a", 39);
    ɵɵelement(5, "i", 40);
    ɵɵelementEnd();
    ɵɵelement(6, "div", 41);
    ɵɵpipe(7, "i18n");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const requirement_r9 = ɵɵnextContext(4).$implicit;
    ɵɵadvance(2);
    ɵɵproperty("id", "dropdown-" + requirement_r9.identifier);
    ɵɵadvance(1);
    ɵɵattribute("aria-labelledby", "dropdown-" + requirement_r9.identifier);
    ɵɵadvance(3);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(7, 3, requirement_r9.description), ɵɵsanitizeHtml);
} }
function PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_ng_container_1_div_1_div_13_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelement(1, "div", 42);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const requirement_r9 = ɵɵnextContext(4).$implicit;
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, requirement_r9.description), ɵɵsanitizeHtml);
} }
function PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_ng_container_1_div_1_div_15_div_2_ng_container_1_ng_container_1_div_1_span_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 34);
    ɵɵtext(1, " * ");
    ɵɵelementEnd();
} }
function PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_ng_container_1_div_1_div_15_div_2_ng_container_1_ng_container_1_div_1_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 35);
    ɵɵelementStart(1, "div", 36);
    ɵɵelement(2, "i", 37);
    ɵɵelementStart(3, "div", 38);
    ɵɵelementStart(4, "a", 39);
    ɵɵelement(5, "i", 40);
    ɵɵelementEnd();
    ɵɵelement(6, "div", 41);
    ɵɵpipe(7, "i18n");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const requirement2_r20 = ɵɵnextContext(4).$implicit;
    ɵɵadvance(2);
    ɵɵproperty("id", "dropdown-" + requirement2_r20.identifier);
    ɵɵadvance(1);
    ɵɵattribute("aria-labelledby", "dropdown-" + requirement2_r20.identifier);
    ɵɵadvance(3);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(7, 3, requirement2_r20.description), ɵɵsanitizeHtml);
} }
function PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_ng_container_1_div_1_div_15_div_2_ng_container_1_ng_container_1_div_1_div_13_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelement(1, "div", 42);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const requirement2_r20 = ɵɵnextContext(4).$implicit;
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, requirement2_r20.description), ɵɵsanitizeHtml);
} }
const _c0$1 = function (a0) { return { "text-secondary": a0 }; };
function PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_ng_container_1_div_1_div_15_div_2_ng_container_1_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div", 45);
    ɵɵelementStart(2, "div", 46);
    ɵɵelement(3, "i", 47);
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 27);
    ɵɵelementStart(5, "div", 11);
    ɵɵelementStart(6, "div", 48);
    ɵɵlistener("click", function PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_ng_container_1_div_1_div_15_div_2_ng_container_1_ng_container_1_div_1_Template_div_click_6_listener() { ɵɵrestoreView(_r30); const requirement2_r20 = ɵɵnextContext(3).$implicit; const category_r2 = ɵɵnextContext(8).$implicit; const ctx_r29 = ɵɵnextContext(); return (ctx_r29.dropdownDocs[category_r2.identifier][requirement2_r20.identifier] = !ctx_r29.dropdownDocs[category_r2.identifier][requirement2_r20.identifier]); });
    ɵɵpipe(7, "i18n");
    ɵɵelement(8, "span", 29);
    ɵɵpipe(9, "i18n");
    ɵɵtemplate(10, PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_ng_container_1_div_1_div_15_div_2_ng_container_1_ng_container_1_div_1_span_10_Template, 2, 0, "span", 30);
    ɵɵelementEnd();
    ɵɵtemplate(11, PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_ng_container_1_div_1_div_15_div_2_ng_container_1_ng_container_1_div_1_div_11_Template, 8, 5, "div", 31);
    ɵɵelementEnd();
    ɵɵelementStart(12, "div", 32);
    ɵɵtemplate(13, PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_ng_container_1_div_1_div_15_div_2_ng_container_1_ng_container_1_div_1_div_13_Template, 3, 3, "div", 8);
    ɵɵelementEnd();
    ɵɵelement(14, "hr", 33);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const requirement2_r20 = ɵɵnextContext(3).$implicit;
    const requirement_r9 = ɵɵnextContext(5).$implicit;
    const category_r2 = ɵɵnextContext(3).$implicit;
    const ctx_r23 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵproperty("ngClass", ɵɵpureFunction1(17, _c0$1, !requirement2_r20.required));
    ɵɵadvance(3);
    ɵɵproperty("title", ɵɵpipeBind1(7, 13, requirement_r9.description));
    ɵɵadvance(2);
    ɵɵclassProp("colapsar", !ctx_r23.dropdownDocs[category_r2.identifier][requirement2_r20.identifier]);
    ɵɵproperty("ngClass", ɵɵpureFunction1(19, _c0$1, !requirement2_r20.required))("innerHTML", ɵɵpipeBind1(9, 15, requirement2_r20.name), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", requirement2_r20.required);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", requirement2_r20 == null ? null : requirement2_r20.description);
    ɵɵadvance(1);
    ɵɵclassProp("d-block", ctx_r23.dropdownDocs[category_r2.identifier][requirement2_r20.identifier])("d-none", !ctx_r23.dropdownDocs[category_r2.identifier][requirement2_r20.identifier]);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", requirement_r9 == null ? null : requirement_r9.description);
} }
function PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_ng_container_1_div_1_div_15_div_2_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_ng_container_1_div_1_div_15_div_2_ng_container_1_ng_container_1_div_1_Template, 15, 21, "div", 8);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const requirement2_r20 = ɵɵnextContext(2).$implicit;
    const ctx_r22 = ɵɵnextContext(9);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r22.audience == requirement2_r20.audience.audienceType || requirement2_r20.audience.audienceType === "ALL");
} }
function PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_ng_container_1_div_1_div_15_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_ng_container_1_div_1_div_15_div_2_ng_container_1_ng_container_1_Template, 2, 1, "ng-container", 8);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const requirement2_r20 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", requirement2_r20.audience !== null);
} }
function PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_ng_container_1_div_1_div_15_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 44);
    ɵɵtemplate(1, PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_ng_container_1_div_1_div_15_div_2_ng_container_1_Template, 2, 1, "ng-container", 8);
    ɵɵelementEnd();
} if (rf & 2) {
    const requirement2_r20 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", requirement2_r20.status === "A" && requirement2_r20.showCheckList);
} }
function PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_ng_container_1_div_1_div_15_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div", 32);
    ɵɵtemplate(2, PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_ng_container_1_div_1_div_15_div_2_Template, 2, 1, "div", 43);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const requirement_r9 = ɵɵnextContext(4).$implicit;
    const category_r2 = ɵɵnextContext(3).$implicit;
    const ctx_r16 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵclassProp("d-block", ctx_r16.dropdownDocs[category_r2.identifier][requirement_r9.identifier])("d-none", !ctx_r16.dropdownDocs[category_r2.identifier][requirement_r9.identifier]);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", requirement_r9.isSimilarTo);
} }
function PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r41 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div", 24);
    ɵɵelementStart(2, "div", 25);
    ɵɵelement(3, "i", 26);
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 27);
    ɵɵelementStart(5, "div", 11);
    ɵɵelementStart(6, "div", 28);
    ɵɵlistener("click", function PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_ng_container_1_div_1_Template_div_click_6_listener() { ɵɵrestoreView(_r41); const requirement_r9 = ɵɵnextContext(3).$implicit; const category_r2 = ɵɵnextContext(3).$implicit; const ctx_r40 = ɵɵnextContext(); return (ctx_r40.dropdownDocs[category_r2.identifier][requirement_r9.identifier] = !ctx_r40.dropdownDocs[category_r2.identifier][requirement_r9.identifier]); });
    ɵɵpipe(7, "i18n");
    ɵɵelement(8, "span", 29);
    ɵɵpipe(9, "i18n");
    ɵɵtemplate(10, PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_ng_container_1_div_1_span_10_Template, 2, 0, "span", 30);
    ɵɵelementEnd();
    ɵɵtemplate(11, PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_ng_container_1_div_1_div_11_Template, 8, 5, "div", 31);
    ɵɵelementEnd();
    ɵɵelementStart(12, "div", 32);
    ɵɵtemplate(13, PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_ng_container_1_div_1_div_13_Template, 3, 3, "div", 8);
    ɵɵelementEnd();
    ɵɵelement(14, "hr", 33);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(15, PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_ng_container_1_div_1_div_15_Template, 3, 5, "div", 8);
    ɵɵelementEnd();
} if (rf & 2) {
    const requirement_r9 = ɵɵnextContext(3).$implicit;
    const category_r2 = ɵɵnextContext(3).$implicit;
    const ctx_r12 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵproperty("ngClass", ɵɵpureFunction1(19, _c0$1, !requirement_r9.required));
    ɵɵadvance(3);
    ɵɵproperty("ngClass", ɵɵpureFunction1(21, _c0$1, !requirement_r9.required))("title", ɵɵpipeBind1(7, 15, requirement_r9.description));
    ɵɵadvance(2);
    ɵɵclassProp("colapsar", !ctx_r12.dropdownDocs[category_r2.identifier][requirement_r9.identifier]);
    ɵɵproperty("ngClass", ɵɵpureFunction1(23, _c0$1, !requirement_r9.required))("innerHTML", ɵɵpipeBind1(9, 17, requirement_r9.name), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", requirement_r9.required);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", requirement_r9 == null ? null : requirement_r9.description);
    ɵɵadvance(1);
    ɵɵclassProp("d-block", ctx_r12.dropdownDocs[category_r2.identifier][requirement_r9.identifier])("d-none", !ctx_r12.dropdownDocs[category_r2.identifier][requirement_r9.identifier]);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", requirement_r9 == null ? null : requirement_r9.description);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", requirement_r9.isSimilarTo);
} }
function PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_ng_container_1_div_1_Template, 16, 25, "div", 8);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const requirement_r9 = ɵɵnextContext(2).$implicit;
    const ctx_r11 = ɵɵnextContext(4);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r11.audience == requirement_r9.audience.audienceType || requirement_r9.audience.audienceType === "ALL");
} }
function PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_ng_container_1_Template, 2, 1, "ng-container", 8);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const requirement_r9 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", requirement_r9.audience !== null);
} }
function PlanRequirementsComponent_div_3_div_1_div_13_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 23);
    ɵɵtemplate(1, PlanRequirementsComponent_div_3_div_1_div_13_div_1_ng_container_1_Template, 2, 1, "ng-container", 8);
    ɵɵelementEnd();
} if (rf & 2) {
    const requirement_r9 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", requirement_r9.status === "A" && requirement_r9.showCheckList);
} }
function PlanRequirementsComponent_div_3_div_1_div_13_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 49);
    ɵɵelement(1, "div", 50);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const category_r2 = ɵɵnextContext(3).$implicit;
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, category_r2 == null ? null : category_r2.alternateName), ɵɵsanitizeHtml);
} }
function PlanRequirementsComponent_div_3_div_1_div_13_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtemplate(1, PlanRequirementsComponent_div_3_div_1_div_13_div_1_Template, 2, 1, "div", 21);
    ɵɵtemplate(2, PlanRequirementsComponent_div_3_div_1_div_13_div_2_Template, 3, 3, "div", 22);
    ɵɵelementEnd();
} if (rf & 2) {
    const category_r2 = ɵɵnextContext(2).$implicit;
    const ctx_r6 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", category_r2 == null ? null : category_r2.requirements);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r6.showNoteCategoryArr[category_r2.identifier] && (category_r2 == null ? null : category_r2.alternateName));
} }
function PlanRequirementsComponent_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r51 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div");
    ɵɵelementStart(2, "div", 9);
    ɵɵelementStart(3, "div", 10);
    ɵɵelementStart(4, "div", 11);
    ɵɵelementStart(5, "div", 12);
    ɵɵelement(6, "h5", 13);
    ɵɵpipe(7, "i18n");
    ɵɵelementEnd();
    ɵɵelementStart(8, "div", 14);
    ɵɵelementStart(9, "div", 15);
    ɵɵlistener("click", function PlanRequirementsComponent_div_3_div_1_Template_div_click_9_listener() { ɵɵrestoreView(_r51); const category_r2 = ɵɵnextContext().$implicit; const ctx_r50 = ɵɵnextContext(); return (ctx_r50.dropdowncategory[category_r2.identifier] = !ctx_r50.dropdowncategory[category_r2.identifier]); });
    ɵɵtemplate(10, PlanRequirementsComponent_div_3_div_1_i_10_Template, 1, 0, "i", 16);
    ɵɵtemplate(11, PlanRequirementsComponent_div_3_div_1_i_11_Template, 1, 0, "i", 17);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelement(12, "hr", 18);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(13, PlanRequirementsComponent_div_3_div_1_div_13_Template, 3, 2, "div", 8);
    ɵɵelementEnd();
} if (rf & 2) {
    const category_r2 = ɵɵnextContext().$implicit;
    const ctx_r3 = ɵɵnextContext();
    ɵɵadvance(6);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(7, 4, category_r2 == null ? null : category_r2.name), ɵɵsanitizeHtml);
    ɵɵadvance(4);
    ɵɵproperty("ngIf", !ctx_r3.dropdowncategory[category_r2.identifier]);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r3.dropdowncategory[category_r2.identifier]);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r3.dropdowncategory[category_r2.identifier] || ctx_r3.idcategory == category_r2.identifier || ctx_r3.dropdowncategoryall);
} }
function PlanRequirementsComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 7);
    ɵɵtemplate(1, PlanRequirementsComponent_div_3_div_1_Template, 14, 6, "div", 8);
    ɵɵelementEnd();
} if (rf & 2) {
    const category_r2 = ctx.$implicit;
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r1.idcategory == category_r2.identifier || ctx_r1.idcategory == "");
} }
class PlanRequirementsComponent {
    constructor(config, _planService) {
        this.config = config;
        this._planService = _planService;
        this.showDescriptionReqArr = {};
        this.showNoteCategoryArr = {};
        this.dropdownDocs = {};
        this.dropdowncategory = {};
        this.tempCategoria = {};
        this.tempCategoriafile = {};
        this.requirementsCategory = null;
        config.placement = 'bottom-right';
        config.autoClose = true;
    }
    ngOnInit() {
        this._planService.showDescriptionReqBoolean$.subscribe((response) => {
            if (!isNullOrUndefined(response)) {
                this.dropdownDocsCategoryAll(response);
            }
        });
        this._planService.showNoteCategoryBoolean$.subscribe((response) => {
            if (!isNullOrUndefined(response)) {
                this.dropdownNoteAll(response);
            }
        });
        if (this.plan.identifier) {
            this._planService.getRequirementsCategory(this.plan.identifier, this.audience, true).subscribe((response) => {
                if (response) {
                    response.forEach((element, index) => {
                        this.dropdownDocs[element.identifier] = {};
                        this.showDescriptionReqArr[element.identifier] = this.showDescriptionReq;
                        this.showNoteCategoryArr[element.identifier] = this.showNoteCategory;
                        if (element.requirements) {
                            element.requirements.forEach((requirement, index2) => {
                                this.dropdownDocs[element.identifier][requirement.identifier] = this.showDescriptionReq;
                                if (requirement.isSimilarTo) {
                                    requirement.isSimilarTo.forEach((requirement2, index3) => {
                                        this.dropdownDocs[element.identifier][requirement2.identifier] = this.showDescriptionReq;
                                    });
                                }
                            });
                        }
                        if (index < 1) {
                            this.dropdowncategory[element.identifier] = true;
                        }
                        else {
                            this.dropdowncategory[element.identifier] = false;
                        }
                    });
                    this.requirementsCategory = response;
                }
            });
        }
    }
    dropdownNoteAll(value) {
        this.requirementsCategory.forEach((element, index) => {
            this.showNoteCategoryArr[element.identifier] = value;
        });
    }
    dropdownDocsCategoryAll(value) {
        this.requirementsCategory.forEach((element, index) => {
            if (value) {
                this.dropdowncategory[element.identifier] = value;
            }
            else {
                if (index < 1) {
                    this.dropdowncategory[element.identifier] = !value;
                }
                else {
                    this.dropdowncategory[element.identifier] = value;
                }
            }
            this.showDescriptionReqArr[element.identifier] = value;
            for (let element2 of Object.keys(this.dropdownDocs[element.identifier])) {
                this.dropdownDocs[element.identifier][element2] = value;
            }
            ;
        });
    }
    ;
    dropdownDocsCategory(id) {
        this.showDescriptionReqArr[id] = !this.showDescriptionReqArr[id];
        for (let element of Object.keys(this.dropdownDocs[id])) {
            this.dropdownDocs[id][element] = this.showDescriptionReqArr[id];
        }
        ;
    }
    ;
    setCategory(category) {
        return category.name;
    }
    getLengthStr(str) {
        if (str) {
            return str.length;
        }
        return 0;
    }
}
/** @nocollapse */ PlanRequirementsComponent.ɵfac = function PlanRequirementsComponent_Factory(t) { return new (t || PlanRequirementsComponent)(ɵɵdirectiveInject(NgbDropdownConfig), ɵɵdirectiveInject(PlansService)); };
/** @nocollapse */ PlanRequirementsComponent.ɵcmp = ɵɵdefineComponent({ type: PlanRequirementsComponent, selectors: [["plan-requirements"]], inputs: { plan: "plan", audience: "audience", idcategory: ["category", "idcategory"], dropdowncategoryall: "dropdowncategoryall", showDescriptionReq: "showDescriptionReq", showNoteCategory: "showNoteCategory" }, decls: 4, vars: 2, consts: [[1, "mb-5", "text-left"], [1, "container", "animated", "fadeIn"], ["class", "box", 4, "ngIf"], ["class", " font-weight-normal ", 4, "ngFor", "ngForOf"], [1, "box"], [1, "text-center", "ml-auto"], ["src", "./assets/public/images/loading.gif", "alt", " "], [1, "font-weight-normal"], [4, "ngIf"], [1, "active-cursor", "d-flex", "bd-highlight", "list-flex", "flex-wrap", "text-dark"], [1, "bd-highlight", "w-100", "order-2"], [1, "d-flex", "bd-highlight"], [1, "mt-3", "mb-3", "flex-grow-1", "bd-highlight"], [1, "font-weight-normal", "mb-0", 3, "innerHTML"], [1, "ico-info", "bd-highlight", "text-right", "mt-3", 2, "font-size", "1rem"], ["ngbDropdown", "", 1, "d-inline-block", 3, "click"], ["class", "pr-1 fas fa-angle-down text-primary active-cursor", 4, "ngIf"], ["class", "pr-1 fas fa-angle-up text-primary active-cursor", 4, "ngIf"], [1, "mt-0", "mr-0", "ml-0", "mb-2-5", "border-secondary"], [1, "pr-1", "fas", "fa-angle-down", "text-primary", "active-cursor"], [1, "pr-1", "fas", "fa-angle-up", "text-primary", "active-cursor"], ["class", "mt-1 font-weight-normal ", 4, "ngFor", "ngForOf"], ["class", "bg-light rounded p-3 mt-2 mb-2 ", 4, "ngIf"], [1, "mt-1", "font-weight-normal"], [1, "d-flex", "bd-highlight", "list-flex", "flex-wrap"], [1, "bd-highlight", "w-5", "w-sm-10", "order-1"], [1, "far", "fa-circle", "text-primary", 2, "font-size", "1.2rem", 3, "ngClass"], [1, "bd-highlight", "w-95", "w-sm-90", "order-2", "active-cursor"], [1, "flex-grow-1", "bd-highlight", 3, "ngClass", "title", "click"], [3, "ngClass", "innerHTML"], ["class", "text-danger", 4, "ngIf"], ["class", "ico-info bd-highlight text-right ", 4, "ngIf"], [1, "active-cursor", "animated", "fadeIn"], [1, "mt-2-5", "mb-2-5"], [1, "text-danger"], [1, "ico-info", "bd-highlight", "text-right"], ["ngbDropdown", "", 1, "d-inline-block"], ["ngbDropdownToggle", "", 1, "pr-1", "fas", "fa-info-circle", "text-secondary-2", "active-cursor", 3, "id"], ["ngbDropdownMenu", "", 1, "p-2", 2, "min-width", "250px", "font-size", "0.8rem"], ["href", "javascript:void(0) ", 1, "text-dark", "float-right"], ["aria-hidden", "true ", 1, "fa", "fa-times", "active-cursor"], [3, "innerHTML"], [1, "pt-2", "text-secondary", 2, "font-size", "14px", 3, "innerHTML"], ["class", "font-weight-normal animated fadeIn ", 4, "ngFor", "ngForOf"], [1, "font-weight-normal", "animated", "fadeIn"], [1, "pl-3", "pl-md-4", "d-flex", "bd-highlight", "list-flex", "flex-wrap"], [1, "bd-highlight", "w-5", "w-sm-10", "order-1", 2, "font-size", "1.3rem"], [1, "far", "fa-circle", 3, "ngClass"], [1, "flex-grow-1", "bd-highlight", 3, "title", "click"], [1, "bg-light", "rounded", "p-3", "mt-2", "mb-2"], [1, "pt-2", 2, "font-size", "14px", 3, "innerHTML"]], template: function PlanRequirementsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵtemplate(2, PlanRequirementsComponent_div_2_Template, 5, 0, "div", 2);
        ɵɵelementEnd();
        ɵɵtemplate(3, PlanRequirementsComponent_div_3_Template, 2, 1, "div", 3);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(2);
        ɵɵproperty("ngIf", !ctx.requirementsCategory);
        ɵɵadvance(1);
        ɵɵproperty("ngForOf", ctx.requirementsCategory);
    } }, directives: [NgIf, NgForOf, NgbDropdown, NgClass, NgbDropdownToggle, NgbDropdownMenu], pipes: [I18nPipe], styles: ["hr[_ngcontent-%COMP%]{margin-right:-15px}.colapsar[_ngcontent-%COMP%]{height:24px;overflow:hidden}.ico-info[_ngcontent-%COMP%]{font-size:.8rem;margin-top:2px;min-width:20px!important}.ico-info[_ngcontent-%COMP%]   i.fa-info[_ngcontent-%COMP%]{opacity:.5}.ico-info[_ngcontent-%COMP%]   i.fa-times[_ngcontent-%COMP%]{font-size:1rem}.b-b[_ngcontent-%COMP%]{border-bottom:1px solid #ddd}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PlanRequirementsComponent, [{
        type: Component,
        args: [{
                selector: 'plan-requirements',
                templateUrl: "./requirements.component.html",
                styleUrls: ['./requirements.component.css']
            }]
    }], function () { return [{ type: NgbDropdownConfig }, { type: PlansService }]; }, { plan: [{
            type: Input
        }], audience: [{
            type: Input
        }], idcategory: [{
            type: Input,
            args: ['category']
        }], dropdowncategoryall: [{
            type: Input,
            args: ['dropdowncategoryall']
        }], showDescriptionReq: [{
            type: Input
        }], showNoteCategory: [{
            type: Input
        }] }); })();

const _c0$2 = ["ejemploidBtn"];
function PlanRequirementsExportComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
function PlanRequirementsExportComponent_ng_container_11_ng_container_9_ng_container_1_ng_container_5_li_1_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 12);
} if (rf & 2) {
    const requirement_r5 = ɵɵnextContext(4).$implicit;
    ɵɵproperty("innerHTML", requirement_r5.description, ɵɵsanitizeHtml);
} }
function PlanRequirementsExportComponent_ng_container_11_ng_container_9_ng_container_1_ng_container_5_li_1_ng_container_4_ng_container_1_ng_container_5_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "li");
    ɵɵelement(1, "span", 7);
    ɵɵelementEnd();
} if (rf & 2) {
    const requirement2_r12 = ɵɵnextContext(3).$implicit;
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", requirement2_r12.name, ɵɵsanitizeHtml);
} }
function PlanRequirementsExportComponent_ng_container_11_ng_container_9_ng_container_1_ng_container_5_li_1_ng_container_4_ng_container_1_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, PlanRequirementsExportComponent_ng_container_11_ng_container_9_ng_container_1_ng_container_5_li_1_ng_container_4_ng_container_1_ng_container_5_li_1_Template, 2, 1, "li", 8);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const requirement2_r12 = ɵɵnextContext(2).$implicit;
    const ctx_r14 = ɵɵnextContext(6);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r14.audience == requirement2_r12.audience.audienceType || requirement2_r12.audience.audienceType === "ALL");
} }
function PlanRequirementsExportComponent_ng_container_11_ng_container_9_ng_container_1_ng_container_5_li_1_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "table", 13);
    ɵɵelementStart(2, "tr");
    ɵɵelementStart(3, "td");
    ɵɵelementStart(4, "ul");
    ɵɵtemplate(5, PlanRequirementsExportComponent_ng_container_11_ng_container_9_ng_container_1_ng_container_5_li_1_ng_container_4_ng_container_1_ng_container_5_Template, 2, 1, "ng-container", 8);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const requirement2_r12 = ɵɵnextContext().$implicit;
    ɵɵadvance(5);
    ɵɵproperty("ngIf", requirement2_r12.audience !== null);
} }
function PlanRequirementsExportComponent_ng_container_11_ng_container_9_ng_container_1_ng_container_5_li_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, PlanRequirementsExportComponent_ng_container_11_ng_container_9_ng_container_1_ng_container_5_li_1_ng_container_4_ng_container_1_Template, 6, 1, "ng-container", 8);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const requirement2_r12 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", requirement2_r12.status === "A" && requirement2_r12.showCheckList);
} }
function PlanRequirementsExportComponent_ng_container_11_ng_container_9_ng_container_1_ng_container_5_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "li");
    ɵɵelement(1, "div", 10);
    ɵɵpipe(2, "i18n");
    ɵɵtemplate(3, PlanRequirementsExportComponent_ng_container_11_ng_container_9_ng_container_1_ng_container_5_li_1_div_3_Template, 1, 1, "div", 11);
    ɵɵtemplate(4, PlanRequirementsExportComponent_ng_container_11_ng_container_9_ng_container_1_ng_container_5_li_1_ng_container_4_Template, 2, 1, "ng-container", 5);
    ɵɵelementEnd();
} if (rf & 2) {
    const requirement_r5 = ɵɵnextContext(3).$implicit;
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 3, requirement_r5.name), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", requirement_r5.description);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", requirement_r5.isSimilarTo);
} }
function PlanRequirementsExportComponent_ng_container_11_ng_container_9_ng_container_1_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, PlanRequirementsExportComponent_ng_container_11_ng_container_9_ng_container_1_ng_container_5_li_1_Template, 5, 5, "li", 8);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const requirement_r5 = ɵɵnextContext(2).$implicit;
    const ctx_r7 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r7.audience == requirement_r5.audience.audienceType || requirement_r5.audience.audienceType === "ALL");
} }
function PlanRequirementsExportComponent_ng_container_11_ng_container_9_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "table", 9);
    ɵɵelementStart(2, "tr");
    ɵɵelementStart(3, "td");
    ɵɵelementStart(4, "ul");
    ɵɵtemplate(5, PlanRequirementsExportComponent_ng_container_11_ng_container_9_ng_container_1_ng_container_5_Template, 2, 1, "ng-container", 8);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const requirement_r5 = ɵɵnextContext().$implicit;
    ɵɵadvance(5);
    ɵɵproperty("ngIf", requirement_r5.audience !== null);
} }
function PlanRequirementsExportComponent_ng_container_11_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, PlanRequirementsExportComponent_ng_container_11_ng_container_9_ng_container_1_Template, 6, 1, "ng-container", 8);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const requirement_r5 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", requirement_r5.status === "A" && requirement_r5.showCheckList);
} }
function PlanRequirementsExportComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "table", 6);
    ɵɵelementStart(2, "tr");
    ɵɵelementStart(3, "td");
    ɵɵelementStart(4, "ul");
    ɵɵelementStart(5, "li");
    ɵɵelementStart(6, "b");
    ɵɵelement(7, "span", 7);
    ɵɵpipe(8, "i18n");
    ɵɵelementEnd();
    ɵɵtemplate(9, PlanRequirementsExportComponent_ng_container_11_ng_container_9_Template, 2, 1, "ng-container", 5);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const category_r3 = ctx.$implicit;
    ɵɵadvance(7);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(8, 2, category_r3.name), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", category_r3 == null ? null : category_r3.requirements);
} }
class PlanRequirementsExportComponent {
    constructor(_planService, exportAsService, templateService) {
        this._planService = _planService;
        this.exportAsService = exportAsService;
        this.templateService = templateService;
        this.templates = {};
        this.requirementsCategory = null;
    }
    ngOnInit() {
        this._planService.requirementsCategory$.subscribe((response) => {
            if (!isNullOrUndefined(response)) {
                if (response.plan && response.audience && response.type) {
                    this.audience = response.audience;
                    this.getRequirementsCategory(response.type, response.plan, response.audience);
                }
            }
        });
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.templates = this.templateService.getTemplates();
        }, 10);
    }
    exportRequirements(type) {
        //  this.exportAsService.export(type,'ejemploid', 'requirements', this.options);
        var element = document.getElementById('ejemploid');
        const opt = {
            margin: 10,
            filename: 'requirements.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { format: 'letter', orientation: 'portrait' },
            pagebreak: { mode: 'avoid-all', before: '#page2el' }
        };
        // New Promise-based usage:
        html2pdf().from(element).set(opt).save();
    }
    export() {
        this.ejemploidBtn.nativeElement.dispatchEvent(new MouseEvent('click'));
    }
    getRequirementsCategory(type, plan, audience) {
        this._planService.getRequirementsCategory(plan, audience, true).subscribe((response) => {
            this.requirementsCategory = response;
            console.log("this.requirementsCategory", this.requirementsCategory);
            setTimeout(() => {
                this.export();
            }, 10);
        });
    }
}
/** @nocollapse */ PlanRequirementsExportComponent.ɵfac = function PlanRequirementsExportComponent_Factory(t) { return new (t || PlanRequirementsExportComponent)(ɵɵdirectiveInject(PlansService), ɵɵdirectiveInject(ExportAsService), ɵɵdirectiveInject(AkeelaTemplateService)); };
/** @nocollapse */ PlanRequirementsExportComponent.ɵcmp = ɵɵdefineComponent({ type: PlanRequirementsExportComponent, selectors: [["plan-requirements-export"]], viewQuery: function PlanRequirementsExportComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$2, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.ejemploidBtn = _t.first);
    } }, inputs: { show: "show" }, decls: 12, vars: 4, consts: [[3, "click"], ["ejemploidBtn", ""], ["id", "ejemploid"], [1, "ak-table"], [4, "ngTemplateOutlet"], [4, "ngFor", "ngForOf"], [1, "ak-intena", "req1"], [3, "innerHTML"], [4, "ngIf"], [1, "ak-intena", "req2"], [2, "margin-top", "20px", 3, "innerHTML"], ["class", "description", 3, "innerHTML", 4, "ngIf"], [1, "description", 3, "innerHTML"], [1, "ak-intena", "req3"]], template: function PlanRequirementsExportComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div");
        ɵɵelementStart(1, "div", 0, 1);
        ɵɵlistener("click", function PlanRequirementsExportComponent_Template_div_click_1_listener() { return ctx.exportRequirements("pdf"); });
        ɵɵtext(3, "export");
        ɵɵelementEnd();
        ɵɵelementStart(4, "div", 2);
        ɵɵelementStart(5, "table", 3);
        ɵɵelementStart(6, "tr");
        ɵɵelementStart(7, "th");
        ɵɵtemplate(8, PlanRequirementsExportComponent_ng_container_8_Template, 1, 0, "ng-container", 4);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(9, "tr");
        ɵɵelementStart(10, "td");
        ɵɵtemplate(11, PlanRequirementsExportComponent_ng_container_11_Template, 10, 4, "ng-container", 5);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵclassProp("d-none", !ctx.show);
        ɵɵadvance(8);
        ɵɵproperty("ngTemplateOutlet", ctx.templates["sectionRequirementsPDFImageHeader"]);
        ɵɵadvance(3);
        ɵɵproperty("ngForOf", ctx.requirementsCategory);
    } }, directives: [NgTemplateOutlet, NgForOf, NgIf], pipes: [I18nPipe], styles: ["", "table.ak-table[_ngcontent-%COMP%] {\n                width: 99%;\n            }\n            \n            #ejemploid[_ngcontent-%COMP%] {\n                padding-left: 5px;\n                padding-right: 5px;\n            }\n            \n            table.ak-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%] {\n                text-align: -webkit-center;\n                margin-left: auto;\n                margin-right: auto;\n            }\n            \n            table.ak-intena[_ngcontent-%COMP%] {\n                width: 100%;\n            }\n            \n            .req1[_ngcontent-%COMP%] {\n                margin-bottom: 15px;\n            }\n            \n            .req2[_ngcontent-%COMP%] {\n                margin-bottom: 10px;\n            }\n            \n            .req2[_ngcontent-%COMP%] {\n                margin-bottom: 5px;\n            }\n            .description[_ngcontent-%COMP%]{\n                border: 1px solid #ddd;\n                 padding: 9px 12px;\n                margin: 5px;\n               margin-left: 0px;\n              font-size: 14px;\n            border-radius: 7px;\n            }"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PlanRequirementsExportComponent, [{
        type: Component,
        args: [{
                selector: 'plan-requirements-export',
                templateUrl: "./requirements-export.component.html",
                styleUrls: ['./requirements-export.component.css']
            }]
    }], function () { return [{ type: PlansService }, { type: ExportAsService }, { type: AkeelaTemplateService }]; }, { show: [{
            type: Input
        }], ejemploidBtn: [{
            type: ViewChild,
            args: ['ejemploidBtn', { static: false }]
        }] }); })();

class AkeelaTemplateService {
    constructor() {
        this.templates = {};
    }
    addTemplate(componentName, template) {
        this.templates[componentName] = template;
    }
    getTemplates() {
        return this.templates;
    }
    getTemplate(componentName) {
        return this.templates[componentName];
    }
}
/** @nocollapse */ AkeelaTemplateService.ɵfac = function AkeelaTemplateService_Factory(t) { return new (t || AkeelaTemplateService)(); };
/** @nocollapse */ AkeelaTemplateService.ɵprov = ɵɵdefineInjectable({ token: AkeelaTemplateService, factory: AkeelaTemplateService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaTemplateService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class ExportAsService {
    constructor() { }
    export(type, identifier, name, options) {
        if (!options)
            options = {};
        this.config = {
            type: type,
            elementId: identifier,
            options: options
        };
        console.log("llego export");
        //this.exportAsService.save(this.config, 'requirements').subscribe((response) => {
        // });
        /* this.exportAsService.get(this.config).subscribe(content => {
         });*/
    }
}
/** @nocollapse */ ExportAsService.ɵfac = function ExportAsService_Factory(t) { return new (t || ExportAsService)(); };
/** @nocollapse */ ExportAsService.ɵprov = ɵɵdefineInjectable({ token: ExportAsService, factory: ExportAsService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ExportAsService, [{
        type: Injectable
    }], function () { return []; }, null); })();

function PlansComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
function PlansComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 32);
    ɵɵelementStart(1, "a", 33);
    ɵɵlistener("click", function PlansComponent_div_9_Template_a_click_1_listener() { ɵɵrestoreView(_r11); const ctx_r10 = ɵɵnextContext(); return ctx_r10.setDocsupport(ctx_r10.plan == null ? null : ctx_r10.plan.identifier, false); });
    ɵɵelement(2, "img", 34);
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function PlansComponent_ng_container_26_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "option", 35);
    ɵɵpipe(2, "i18n");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const option_r12 = ctx.$implicit;
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("value", option_r12.audienceType)("innerHTML", ɵɵpipeBind1(2, 3, option_r12 == null ? null : option_r12.name), ɵɵsanitizeHtml)("selected", ctx_r2.filterDocs["audience"]);
} }
function PlansComponent_ng_container_33_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "option", 35);
    ɵɵpipe(2, "i18n");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const option_r13 = ctx.$implicit;
    const ctx_r3 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("value", option_r13.identifier)("innerHTML", ɵɵpipeBind1(2, 3, option_r13 == null ? null : option_r13.name), ɵɵsanitizeHtml)("selected", ctx_r3.filterDocs["category"]);
} }
function PlansComponent_i_41_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 36);
} }
function PlansComponent_i_42_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 37);
} }
function PlansComponent_i_47_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 36);
} }
function PlansComponent_i_48_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 37);
} }
function PlansComponent_div_49_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 40);
    ɵɵelementStart(1, "div", 41);
    ɵɵelement(2, "plan-requirements", 42);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const pm_r14 = ɵɵnextContext().$implicit;
    const ctx_r15 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵproperty("showNoteCategory", ctx_r15.showNoteCategory)("showDescriptionReq", ctx_r15.showDescriptionReq)("dropdowncategoryall", ctx_r15.dropdowncategoryall)("category", ctx_r15.filterDocs["category"])("audience", pm_r14.audienceType)("plan", ctx_r15.plan);
} }
function PlansComponent_div_49_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 38);
    ɵɵtemplate(1, PlansComponent_div_49_div_1_Template, 3, 6, "div", 39);
    ɵɵelementEnd();
} if (rf & 2) {
    const pm_r14 = ctx.$implicit;
    const ctx_r8 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r8.filterDocs["audience"] == pm_r14.audienceType || (ctx_r8.plan == null ? null : ctx_r8.plan.personMarkets == null ? null : ctx_r8.plan.personMarkets.length) < 2);
} }
function PlansComponent_ng_container_57_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
const _c0$3 = function (a0) { return { $implicit: a0 }; };
class PlansComponent {
    constructor(formBuilder, templateService, _planService, exportAsService) {
        this.formBuilder = formBuilder;
        this.templateService = templateService;
        this._planService = _planService;
        this.exportAsService = exportAsService;
        this.container = new EventEmitter();
        this.docsupport = [];
        this.menuActive = 'LEGAL';
        this.filterDocs = {};
        this.options = {};
        this.categorys = [];
        this.dropdowncategoryall = false;
        this.showDescriptionReqBoolean = false;
        this.showNoteBoolean = false;
        this.templates = {};
    }
    ngOnInit() {
        this.showDescriptionReqBoolean = this.showDescriptionReq;
        this.showNoteBoolean = this.showNoteCategory;
        this.filterDocs['category'] = '';
        if (this.plan.personMarkets.length > 0) {
            this.filterDocs['audience'] = this.plan.personMarkets[0].audienceType;
            this.setCategory();
        }
        this.filterDocsform = this.formBuilder.group({
            audience: ['', Validators.required],
            category: ['', Validators.required]
        });
        this._planService.docsupport$.subscribe((docsupport) => {
            if (docsupport) {
                this.docsupport = docsupport;
            }
        });
    }
    setContiner(param) {
        this.container.emit(param);
    }
    dropdownDocsCategory() {
        this.showDescriptionReqBoolean = !this.showDescriptionReqBoolean;
        this._planService.setShowDescriptionReqBoolean((this.showDescriptionReqBoolean));
    }
    dropdownNotes() {
        this.showNoteBoolean = !this.showNoteBoolean;
        this._planService.setShowNoteCategoryBoolean((this.showNoteBoolean));
    }
    setCategory() {
        if (this.plan.identifier) {
            this.categorys = [];
            this.filterDocs['category'] = '';
            this._planService.getRequirementsCategory(this.plan.identifier, this.filterDocs['audience']).subscribe((response) => {
                this.categorys = response;
            });
        }
    }
    export(type) {
        let tmp = {
            type: type,
            plan: this.plan.identifier,
            audience: this.filterDocs['audience']
        };
        this._planService.setRequirementsCategory(tmp);
    }
    setDocsupport(id, param) {
        this._planService.setDocsupport(id, param);
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.templates = this.templateService.getTemplates();
        }, 10);
    }
}
/** @nocollapse */ PlansComponent.ɵfac = function PlansComponent_Factory(t) { return new (t || PlansComponent)(ɵɵdirectiveInject(FormBuilder), ɵɵdirectiveInject(AkeelaTemplateService), ɵɵdirectiveInject(PlansService), ɵɵdirectiveInject(ExportAsService)); };
/** @nocollapse */ PlansComponent.ɵcmp = ɵɵdefineComponent({ type: PlansComponent, selectors: [["plans"]], inputs: { plan: "plan", product: "product", showDescriptionReq: "showDescriptionReq", showNoteCategory: "showNoteCategory", notClose: "notClose", menuActive: "menuActive" }, outputs: { container: "container" }, decls: 58, vars: 35, consts: [[1, "ak-full-modal", "bg-gray"], [1, "header"], [1, "d-flex", "bd-highlight", "pr-2", "pl-2", "pb-2"], [1, "pt-1", "bd-highlight", "flex-grow-1"], [4, "ngTemplateOutlet"], [1, "bd-highlight", "pr-4", "pt-4"], ["href", "javascript:void(0)", 1, "text-primary", 3, "click"], ["class", " bd-highlight pt-2 ", 4, "ngIf"], [1, "body", "container"], [1, "text-md-left"], [1, "mb-2", "mt-4", "font-weight-bold", 3, "innerHTML"], [1, "font-weight-bold", "mt-4", 3, "innerHTML"], [1, "font-weight-normal", "mb-3", 3, "innerHTML"], ["novalidate", "", 1, "animated", "fadeIn", 3, "formGroup"], [1, "row"], [1, "col-12", "col-md-4", "form-group"], [1, "d-block", "font-weight-bold"], ["formControlName", "audience", 1, "filter", "border-primary", "form-control", 3, "value", "change"], [4, "ngFor", "ngForOf"], ["formControlName", "category", 1, "filter", "border-primary", "form-control", 3, "value"], [3, "value", "innerHTML"], [1, "col-12", "mt-3", "mb-2"], [1, "col-12", "col-md-4", "mt-3"], ["title", "Mostrar/Ocultar Descriptiones", 1, "float-right", 3, "click"], ["class", "fas fa-toggle-on active-cursor  text-primary  pr-2 ", "style", "font-size:1.2rem ", 4, "ngIf"], ["class", "fas fa-toggle-off active-cursor  text-secondary  pr-2", "style", "font-size:1.2rem ", 4, "ngIf"], ["title", "Mostrar/Ocultar Notas", 1, "float-right", 3, "click"], ["class", "mt-2", 4, "ngFor", "ngForOf"], [1, ""], [1, "box", "shadow-sm", "bg-white", "rounded", "animated", "fadeIn", "p-4"], [3, "product", "plan"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "bd-highlight", "pt-2"], ["href", "javascript:void(0)", 1, "text-dark", 3, "click"], ["src", "assets/public/images/close.svg", 1, "size-img", "close"], [3, "value", "innerHTML", "selected"], [1, "fas", "fa-toggle-on", "active-cursor", "text-primary", "pr-2", 2, "font-size", "1.2rem"], [1, "fas", "fa-toggle-off", "active-cursor", "text-secondary", "pr-2", 2, "font-size", "1.2rem"], [1, "mt-2"], ["class", "row text-justify", 4, "ngIf"], [1, "row", "text-justify"], [1, "col-12"], [3, "showNoteCategory", "showDescriptionReq", "dropdowncategoryall", "category", "audience", "plan"]], template: function PlansComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementContainerStart(0);
        ɵɵelementStart(1, "div", 0);
        ɵɵelementStart(2, "div", 1);
        ɵɵelementStart(3, "div", 2);
        ɵɵelementStart(4, "div", 3);
        ɵɵtemplate(5, PlansComponent_ng_container_5_Template, 1, 0, "ng-container", 4);
        ɵɵelementEnd();
        ɵɵelementStart(6, "div", 5);
        ɵɵelementStart(7, "a", 6);
        ɵɵlistener("click", function PlansComponent_Template_a_click_7_listener() { return ctx.export("pdf"); });
        ɵɵtext(8, " Descargar PDF ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(9, PlansComponent_div_9_Template, 3, 0, "div", 7);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(10, "div", 8);
        ɵɵelementContainerStart(11);
        ɵɵelementStart(12, "div", 9);
        ɵɵelement(13, "h3", 10);
        ɵɵpipe(14, "i18n");
        ɵɵelement(15, "h4", 11);
        ɵɵpipe(16, "i18n");
        ɵɵelement(17, "div", 12);
        ɵɵpipe(18, "i18n");
        ɵɵelementEnd();
        ɵɵelementStart(19, "div");
        ɵɵelementStart(20, "form", 13);
        ɵɵelementStart(21, "div", 14);
        ɵɵelementStart(22, "div", 15);
        ɵɵelementStart(23, "label", 16);
        ɵɵtext(24, "Tipo de solicitante");
        ɵɵelementEnd();
        ɵɵelementStart(25, "select", 17);
        ɵɵlistener("change", function PlansComponent_Template_select_change_25_listener() { return ctx.setCategory(); });
        ɵɵtemplate(26, PlansComponent_ng_container_26_Template, 3, 5, "ng-container", 18);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(27, "div", 15);
        ɵɵelementStart(28, "label", 16);
        ɵɵtext(29, "Tipo de perfil");
        ɵɵelementEnd();
        ɵɵelementStart(30, "select", 19);
        ɵɵelement(31, "option", 20);
        ɵɵpipe(32, "i18n");
        ɵɵtemplate(33, PlansComponent_ng_container_33_Template, 3, 5, "ng-container", 18);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(34, "div", 14);
        ɵɵelementStart(35, "div", 21);
        ɵɵelementStart(36, "a", 6);
        ɵɵlistener("click", function PlansComponent_Template_a_click_36_listener() { return ctx.export("pdf"); });
        ɵɵtext(37, " Descargar recaudos en PDF ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(38, "div", 22);
        ɵɵtext(39, " Mostrar descripci\u00F3n ");
        ɵɵelementStart(40, "span", 23);
        ɵɵlistener("click", function PlansComponent_Template_span_click_40_listener() { return ctx.dropdownDocsCategory(); });
        ɵɵtemplate(41, PlansComponent_i_41_Template, 1, 0, "i", 24);
        ɵɵtemplate(42, PlansComponent_i_42_Template, 1, 0, "i", 25);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(43, "div", 14);
        ɵɵelementStart(44, "div", 22);
        ɵɵtext(45, " Mostrar notas ");
        ɵɵelementStart(46, "span", 26);
        ɵɵlistener("click", function PlansComponent_Template_span_click_46_listener() { return ctx.dropdownNotes(); });
        ɵɵtemplate(47, PlansComponent_i_47_Template, 1, 0, "i", 24);
        ɵɵtemplate(48, PlansComponent_i_48_Template, 1, 0, "i", 25);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(49, PlansComponent_div_49_Template, 2, 1, "div", 27);
        ɵɵelementContainerEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementContainerEnd();
        ɵɵelementContainerStart(50);
        ɵɵelementStart(51, "div", 21);
        ɵɵelementStart(52, "a", 6);
        ɵɵlistener("click", function PlansComponent_Template_a_click_52_listener() { return ctx.export("pdf"); });
        ɵɵtext(53, " Descargar recaudos en PDF ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(54, "div", 28);
        ɵɵelementStart(55, "div", 29);
        ɵɵelement(56, "plan-detail", 30);
        ɵɵtemplate(57, PlansComponent_ng_container_57_Template, 1, 0, "ng-container", 31);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵclassProp("d-none", false);
        ɵɵadvance(4);
        ɵɵproperty("ngTemplateOutlet", ctx.templates["imgLogo"]);
        ɵɵadvance(4);
        ɵɵproperty("ngIf", !ctx.notClose);
        ɵɵadvance(2);
        ɵɵclassProp("d-none", !ctx.plan.termsOfService);
        ɵɵadvance(2);
        ɵɵproperty("innerHTML", ɵɵpipeBind1(14, 25, "@i18n-menu-label-client-doc-support"), ɵɵsanitizeHtml);
        ɵɵadvance(2);
        ɵɵproperty("innerHTML", ɵɵpipeBind1(16, 27, ctx.plan == null ? null : ctx.plan.shortDescription), ɵɵsanitizeHtml);
        ɵɵadvance(2);
        ɵɵproperty("innerHTML", ɵɵpipeBind1(18, 29, "@i18n-text-plan-recaudos-subtitle"), ɵɵsanitizeHtml);
        ɵɵadvance(3);
        ɵɵproperty("formGroup", ctx.filterDocsform);
        ɵɵadvance(5);
        ɵɵproperty("value", ctx.filterDocs["audience"]);
        ɵɵadvance(1);
        ɵɵproperty("ngForOf", ctx.plan == null ? null : ctx.plan.personMarkets);
        ɵɵadvance(4);
        ɵɵproperty("value", ctx.filterDocs["category"]);
        ɵɵadvance(1);
        ɵɵproperty("value", "")("innerHTML", ɵɵpipeBind1(32, 31, "Todos"), ɵɵsanitizeHtml);
        ɵɵadvance(2);
        ɵɵproperty("ngForOf", ctx.categorys);
        ɵɵadvance(8);
        ɵɵproperty("ngIf", ctx.showDescriptionReqBoolean);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.showDescriptionReqBoolean);
        ɵɵadvance(5);
        ɵɵproperty("ngIf", ctx.showNoteBoolean);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.showNoteBoolean);
        ɵɵadvance(1);
        ɵɵproperty("ngForOf", ctx.plan == null ? null : ctx.plan.personMarkets);
        ɵɵadvance(7);
        ɵɵproperty("product", ctx.product)("plan", ctx.plan);
        ɵɵadvance(1);
        ɵɵproperty("ngTemplateOutlet", ctx.templates["sectionForm"])("ngTemplateOutletContext", ɵɵpureFunction1(33, _c0$3, ctx.plan));
    } }, styles: [".title[_ngcontent-%COMP%]{color:#4a4a4a;line-height:2rem;margin-bottom:2rem;margin-top:2rem}.box[_ngcontent-%COMP%]{border-radius:10px!important;box-shadow:0 2px 4px 0 hsla(0,0%,91.8%,.5)}.ak-full-modal[_ngcontent-%COMP%]{margin-left:-15px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PlansComponent, [{
        type: Component,
        args: [{
                selector: 'plans',
                templateUrl: './plans.component.html',
                styleUrls: ['./plans.component.css']
            }]
    }], function () { return [{ type: FormBuilder }, { type: AkeelaTemplateService }, { type: PlansService }, { type: ExportAsService }]; }, { plan: [{
            type: Input
        }], product: [{
            type: Input
        }], showDescriptionReq: [{
            type: Input
        }], showNoteCategory: [{
            type: Input
        }], notClose: [{
            type: Input
        }], container: [{
            type: Output
        }], menuActive: [{
            type: Input
        }] }); })();

class PlansService {
    constructor(_httpService) {
        this._httpService = _httpService;
        this.print$ = new BehaviorSubject(null);
        this.requirementsCategory$ = new BehaviorSubject(null);
        this.docsupport$ = new BehaviorSubject([]);
        this.showDescriptionReqBoolean$ = new BehaviorSubject(null);
        this.showNoteCategoryBoolean$ = new BehaviorSubject(null);
        this.showContainerPlan$ = new BehaviorSubject(true);
        this.currentPlan$ = new BehaviorSubject(null);
    }
    setShowContainerPlan(showContainerPlan) {
        this.showContainerPlan$.next(showContainerPlan);
    }
    setPrint(print) {
        this.print$.next(print);
    }
    setShowDescriptionReqBoolean(showDescriptionReqBoolean) {
        this.showDescriptionReqBoolean$.next(showDescriptionReqBoolean);
    }
    setShowNoteCategoryBoolean(showNoteCategoryBoolean) {
        this.showNoteCategoryBoolean$.next(showNoteCategoryBoolean);
    }
    setRequirementsCategory(requirementsCategory) {
        this.requirementsCategory$.next(requirementsCategory);
    }
    setDocsupport(id, param) {
        let tmp = this.docsupport$.getValue();
        tmp[id] = param;
        this.docsupport$.next(tmp);
        this.setShowContainerPlan(!param);
    }
    resetDocsupport() {
        this.docsupport$.next([]);
    }
    getRequirementsCategory(idPlan, audience, withRequirements) {
        return new Observable(resolve => {
            let request;
            if (withRequirements) {
                request = { "audience": audience,
                    "withRequirements": withRequirements
                };
            }
            else {
                request = { "audience": audience };
            }
            const params = {
                endpoint: {
                    name: 'requirements$category$get',
                    params: {
                        path: { "idPlan": idPlan },
                        request: request,
                        body: {}
                    }
                }
            };
            this._httpService.executeRequest(params.endpoint.name, params.endpoint.params, true).subscribe((response) => {
                resolve.next(response);
                resolve.complete();
            }, (error) => {
                resolve.next(null);
                resolve.complete();
            });
        });
    }
}
/** @nocollapse */ PlansService.ɵfac = function PlansService_Factory(t) { return new (t || PlansService)(ɵɵinject(HttpService)); };
/** @nocollapse */ PlansService.ɵprov = ɵɵdefineInjectable({ token: PlansService, factory: PlansService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PlansService, [{
        type: Injectable
    }], function () { return [{ type: HttpService }]; }, null); })();

class AkeelaTemplateComponent {
    constructor(templateService) {
        this.templateService = templateService;
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.contentsRef.forEach((item, index) => {
                const template = this.templatesRef.find((_template, templateIndex) => templateIndex === index);
                this.templateService.addTemplate(item.componentName, template);
            });
        }, 10);
    }
}
/** @nocollapse */ AkeelaTemplateComponent.ɵfac = function AkeelaTemplateComponent_Factory(t) { return new (t || AkeelaTemplateComponent)(ɵɵdirectiveInject(AkeelaTemplateService)); };
/** @nocollapse */ AkeelaTemplateComponent.ɵcmp = ɵɵdefineComponent({ type: AkeelaTemplateComponent, selectors: [["products-akeela-template"]], contentQueries: function AkeelaTemplateComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵɵcontentQuery(dirIndex, ContentDirective, false);
        ɵɵcontentQuery(dirIndex, ContentDirective, false, TemplateRef);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.contentsRef = _t);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.templatesRef = _t);
    } }, decls: 1, vars: 0, template: function AkeelaTemplateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementContainer(0);
    } }, styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaTemplateComponent, [{
        type: Component,
        args: [{
                selector: 'products-akeela-template',
                templateUrl: './akeela-template.component.html',
                styleUrls: ['./akeela-template.component.css']
            }]
    }], function () { return [{ type: AkeelaTemplateService }]; }, { contentsRef: [{
            type: ContentChildren,
            args: [ContentDirective]
        }], templatesRef: [{
            type: ContentChildren,
            args: [ContentDirective, { read: TemplateRef }]
        }] }); })();

function DetailComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
const _c0$4 = function (a0) { return { $implicit: a0 }; };
class DetailComponent {
    constructor(templateService, _planService) {
        this.templateService = templateService;
        this._planService = _planService;
        this.menuActive = 'LEGAL';
        this.isCollapsed = {};
        this.templates = {};
        this.options = {
            orientation: 'landscape',
            margin: 15
        };
    }
    ngOnInit() {
        this._planService.docsupport$.subscribe((docsupport) => {
        });
    }
    setCollapsed(id) {
        if (this.isCollapsed[id]) {
            this.isCollapsed[id] = false;
        }
        else {
            this.isCollapsed[id] = true;
        }
    }
    select(identifier) {
        this._planService.currentPlan$.next(identifier);
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.templates = this.templateService.getTemplates();
        }, 10);
    }
}
/** @nocollapse */ DetailComponent.ɵfac = function DetailComponent_Factory(t) { return new (t || DetailComponent)(ɵɵdirectiveInject(AkeelaTemplateService), ɵɵdirectiveInject(PlansService)); };
/** @nocollapse */ DetailComponent.ɵcmp = ɵɵdefineComponent({ type: DetailComponent, selectors: [["plan-detail"]], inputs: { plan: "plan", product: "product", menuActive: "menuActive" }, decls: 1, vars: 4, consts: [[4, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function DetailComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, DetailComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
    } if (rf & 2) {
        ɵɵproperty("ngTemplateOutlet", ctx.templates["detailForm"])("ngTemplateOutletContext", ɵɵpureFunction1(2, _c0$4, ctx.plan));
    } }, directives: [NgTemplateOutlet], styles: [".box[_ngcontent-%COMP%]{background-color:#fff;box-shadow:0 2px 4px 0 hsla(0,0%,91.8%,.5);color:#4a4a4a;font-size:.75rem;margin-bottom:2rem;margin-left:auto;margin-right:auto;min-height:10rem;padding:15px;width:800px}.c-label[_ngcontent-%COMP%]{color:#777;font-size:.875rem}@media (max-width:768px){.box[_ngcontent-%COMP%]{font-size:1rem!important}}@media (max-width:992px){.box[_ngcontent-%COMP%]{width:auto!important}}.title[_ngcontent-%COMP%]{font-size:1rem;margin-bottom:1rem}.m-b-1[_ngcontent-%COMP%]{margin-bottom:.75rem}.m-t-1[_ngcontent-%COMP%]{margin-top:.75rem}.m-l-1_5[_ngcontent-%COMP%]{margin-left:1.5rem}.img-plan[_ngcontent-%COMP%]{background-color:#d8d8d8;border:1px solid #979797;float:left;height:197px;margin-right:1rem;width:159px}.plan-descripotion[_ngcontent-%COMP%]{border-bottom:.5px solid #ddd;margin-bottom:1rem;padding-bottom:1rem}.text-color-blue[_ngcontent-%COMP%]{color:#4a90e2}.text-size-1[_ngcontent-%COMP%]{font-size:14px}.text-size-2[_ngcontent-%COMP%]{font-size:5px}.text-size-3[_ngcontent-%COMP%]{font-size:13px}.text-bold[_ngcontent-%COMP%]{font-weight:700}.text-weight-light[_ngcontent-%COMP%]{font-weight:lighter}.text-color-black[_ngcontent-%COMP%]{color:#000}.text-primary[_ngcontent-%COMP%]{color:#4a90e2!important}.cursor[_ngcontent-%COMP%]{cursor:pointer}.class-hidden[_ngcontent-%COMP%]{display:block}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DetailComponent, [{
        type: Component,
        args: [{
                selector: "plan-detail",
                templateUrl: "./detail.component.html",
                styleUrls: ["./detail.component.css"]
            }]
    }], function () { return [{ type: AkeelaTemplateService }, { type: PlansService }]; }, { plan: [{
            type: Input
        }], product: [{
            type: Input
        }], menuActive: [{
            type: Input
        }] }); })();

class ProductsPlansModule {
}
/** @nocollapse */ ProductsPlansModule.ɵmod = ɵɵdefineNgModule({ type: ProductsPlansModule });
/** @nocollapse */ ProductsPlansModule.ɵinj = ɵɵdefineInjector({ factory: function ProductsPlansModule_Factory(t) { return new (t || ProductsPlansModule)(); }, providers: [ProductsService, PlansService, ExportAsService, AkeelaTemplateService], imports: [[
            I18nModule,
            RouterModule,
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            NgbModule.forRoot()
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(ProductsPlansModule, { declarations: [ProductsComponent, PlansComponent, RecursiveComponent, DetailComponent, PlanRequirementsComponent, PlanRequirementsExportComponent, AkeelaTemplateComponent, ContentDirective], imports: [I18nModule,
        RouterModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule, NgbModule], exports: [ProductsComponent, PlansComponent, AkeelaTemplateComponent, ContentDirective, PlanRequirementsComponent, PlanRequirementsExportComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(ProductsPlansModule, [{
        type: NgModule,
        args: [{
                imports: [
                    I18nModule,
                    RouterModule,
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    NgbModule.forRoot()
                ],
                exports: [ProductsComponent, PlansComponent, AkeelaTemplateComponent, ContentDirective, PlanRequirementsComponent, PlanRequirementsExportComponent],
                providers: [ProductsService, PlansService, ExportAsService, AkeelaTemplateService],
                declarations: [ProductsComponent, PlansComponent, RecursiveComponent, DetailComponent, PlanRequirementsComponent, PlanRequirementsExportComponent, AkeelaTemplateComponent, ContentDirective]
            }]
    }], null, null); })();
ɵɵsetComponentScope(PlansComponent, [RouterOutlet, RouterLink, RouterLinkWithHref, RouterLinkActive, ɵangular_packages_router_router_l, NgClass, NgComponentOutlet, NgForOf, NgIf, NgTemplateOutlet, NgStyle, NgSwitch, NgSwitchCase, NgSwitchDefault, NgPlural, NgPluralCase, ɵangular_packages_forms_forms_y, NgSelectOption, ɵangular_packages_forms_forms_x, DefaultValueAccessor, NumberValueAccessor, RangeValueAccessor, CheckboxControlValueAccessor, SelectControlValueAccessor, SelectMultipleControlValueAccessor, RadioControlValueAccessor, NgControlStatus, NgControlStatusGroup, RequiredValidator, MinLengthValidator, MaxLengthValidator, PatternValidator, CheckboxRequiredValidator, EmailValidator, NgModel, NgModelGroup, NgForm, FormControlDirective, FormGroupDirective, FormControlName, FormGroupName, FormArrayName, NgbAccordion, NgbPanel, NgbPanelTitle, NgbPanelContent, NgbPanelHeader, NgbPanelToggle, NgbAlert, NgbButtonLabel, NgbCheckBox, NgbRadioGroup, NgbRadio, NgbCarousel, NgbSlide, NgbCollapse, NgbDatepicker, NgbInputDatepicker, NgbDropdown, NgbDropdownAnchor, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem, ɵm, NgbPagination, NgbPaginationEllipsis, NgbPaginationFirst, NgbPaginationLast, NgbPaginationNext, NgbPaginationNumber, NgbPaginationPrevious, NgbPopover, NgbProgressbar, NgbRating, NgbTabset, NgbTab, NgbTabContent, NgbTabTitle, NgbTimepicker, NgbTooltip, NgbTypeahead, NgbHighlight, ProductsComponent, PlansComponent, RecursiveComponent, DetailComponent, PlanRequirementsComponent, PlanRequirementsExportComponent, AkeelaTemplateComponent, ContentDirective], [I18nPipe, FormatPipe, NumberI18nPipe, NumberTransformPipe, AsyncPipe, UpperCasePipe, LowerCasePipe, JsonPipe, SlicePipe, DecimalPipe, PercentPipe, TitleCasePipe, CurrencyPipe, DatePipe, I18nPluralPipe, I18nSelectPipe, KeyValuePipe]);

/*
 * Public API Surface of products-plans
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AkeelaTemplateComponent, AkeelaTemplateService, ContentDirective, ExportAsService, PlanRequirementsComponent, PlanRequirementsExportComponent, PlansComponent, PlansService, ProductsComponent, ProductsPlansModule, ProductsService };
//# sourceMappingURL=akeela-products-plans.js.map
